export default "__VITE_ASSET__BF5cyUfM__"